// extracted by mini-css-extract-plugin
export default {"productCarousel":"G1-z"};